import React from 'react';
import { Link } from 'react-router-dom';

export default function PaymentSuccess() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white relative">
      {/* Background Effects */}
      <div className="fixed inset-0 green-gradient opacity-50"></div>
      <div className="fixed top-20 left-1/4 w-[500px] h-[500px] bg-[#00FF9D]/5 rounded-full blur-[100px]"></div>
      <div className="fixed bottom-20 right-1/4 w-[500px] h-[500px] bg-[#00FF9D]/5 rounded-full blur-[100px]"></div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 py-12">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-8 mono">Merci !</h1>
          <p className="text-xl text-gray-400 mb-8">
            Votre paiement a bien été pris en compte.
          </p>
          <p className="text-lg text-[#00FF9D] mb-12">
            Pensez à recharger la page de votre extension pour voir les nouvelles features ;)
          </p>
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#00FF9D] hover:text-[#00FF9D]/80"
          >
            <span>← Retour à l'accueil</span>
          </Link>
        </div>
      </div>
    </div>
  );
} 